// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__FZo7Q","messages":"MessagesList_messages__YI6bJ"};